// OS results js

function redirRefTracking() {
    if (typeof window.global_tracking !== 'undefined') {
        const newUrl = new URL(window.location.toString());

        // Remove trailing slash
        newUrl.pathname = newUrl.pathname.replace(/\/+$/, '');

        // Add tracking:
        newUrl.searchParams.append('ref', window.global_tracking);

        // Redirect:
        setTimeout(() => {
            window.location = newUrl;
        }, 1000);

        return;
    }

    // No tracking found yet:
    setTimeout(() => {
        redirRefTracking();
    }, 200);
}

function checkRef() {
    const urlParams = new URLSearchParams(window.location.search);

    if (!urlParams.has('ref')) {
        // Add loading class:
        const compareModules = document.getElementsByClassName('os-widget-component');

        Array.prototype.forEach.call(compareModules, (element) => {
            element.classList.add('loading');
        });

        // Check whether we have global tracking
        setTimeout(() => {
            redirRefTracking();
        }, 1000);
    }
}

function removeParagraph() {
    const interval = setInterval(() => {
        const paragraph = document.querySelector('.css-1jqr1wq .css-b45y8e');
        if (paragraph) {
            paragraph.remove();
            clearInterval(interval);
        }
    }, 100);
}

// On load:
document.addEventListener('DOMContentLoaded', () => {
    checkRef();
    // removeParagraph(); 
});
